module.exports = __webpack_public_path__ + "static/media/013.4b2c91e3.jpg";